export default "__VITE_ASSET__ef164a67__"